var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddClient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 88,
    viewBox: "0 0 75 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.4999,
    cy: 23.0769,
    rx: 20.1923,
    ry: 23.0769,
    fill: "#4880FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 77.8852C75 90.6302 58.2107 86.5391 37.5 86.5391C16.7893 86.5391 0 90.6302 0 77.8852C0 65.1402 16.7893 49.0391 37.5 49.0391C58.2107 49.0391 75 65.1402 75 77.8852Z",
    fill: "#4880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddClient);
export default __webpack_public_path__ + "static/media/add-client.68a98eb411f0ef90c4ad9cab3810853f.svg";
export { ForwardRef as ReactComponent };